(function () {
    'use strict';


    angular.module('doclr.adminagenda', [
        'doclr.components.agenda',
        'doclr.components.adminagendacomponents',
        'doclr.resources.api',
        'doclr.praktijk',
        'ui.router',
        'doclr.afspraak.monitor',
        'ui.bootstrap.typeahead'
    ])
        .constant('agendaBoundaries', {minDate: moment().subtract(2, 'years'), maxDate: moment().add(2, 'years')})
        .config(function ($stateProvider, agendaNestedStatesConfigurator) {
            $stateProvider.state('agendaid', {
                url: '/agendaid/:agendaId',
                params: {agendaId: null},
                onEnter: function ($state, $stateParams) {
                    $state.go('agenda.initial', {agendaId: '/apiv0/agenda/' + $stateParams.agendaId});
                }
            });

            $stateProvider.state('agenda', {
                abstract: true,
                url: '/agenda',
                template: '<div ui-view></div>',
                resolve: {
                    agendas: function (AgendaOverzicht, praktijkContext) {
                        return AgendaOverzicht.get(praktijkContext.id);
                    },
                    resources: function (ResourceOverzicht, praktijkContext) {
                        return ResourceOverzicht.get(praktijkContext.id);
                    }
                }
            });

            $stateProvider.state('agenda.initial', {
                url: '',
                params: {
                    dag: null,
                    agendaId: null
                },
                resolve: {
                    slicesLoader: function (slicesService, agendaCriteriaFactory, praktijkContext, agendas, resources, $stateParams) {
                        var criteria = agendaCriteriaFactory(praktijkContext.id, agendas, resources, $stateParams.dag);
                        if ($stateParams.agendaId) {
                            criteria = criteria.naarWeekModus($stateParams.agendaId);
                        } else {

                        }
                        return slicesService.load(criteria);
                    },
                    afspraakTypes: function (AfspraakMogelijkheidTypes, praktijkContext) {
                        return AfspraakMogelijkheidTypes.getTypes(praktijkContext.id);
                    }
                },
                views: {
                    '': {
                        templateUrl: '/partials/components/page.with.sidebar.html'
                    },
                    'content@agenda.initial': {
                        templateUrl: '/partials/adminagenda/adminagenda.overzicht.html',
                        controller: function ($scope, agendas, afspraakTypes, resources) {
                            $scope.agendas = agendas;
                            $scope.resources = resources;
                            $scope.afspraakTypes = afspraakTypes;

                            $scope.agendaContextOptions = {
                                agendas: agendas
                            };
                        }
                    },
                    'sidebar@agenda.initial': {
                        templateUrl: '/partials/adminagenda/adminagenda.sidebar.html',
                        controller: function ($scope, agendas, slicesService, agendaBoundaries, resources, UserProfileService) {
                            $scope.agendas = agendas;
                            $scope.resources = resources;
                            $scope.slicesLoader = slicesService.slicesLoader;
                            $scope.agendaBoundaries = agendaBoundaries;
                            $scope.userProfileService = UserProfileService;

                            $scope.isSelectionActive = function () {
                                return $scope.slicesLoader.criteria.modus === 'dag' &&
                                    ($scope.slicesLoader.criteria.agendas.length > 0 || $scope.slicesLoader.criteria.resources.length > 0);
                            };

                            $scope.applySavedView = function (view) {
                                const calendarIds = view.calendarIds
                                    .map(uuid => agendas.findAgendaVoorId('/apiv0/agenda/' + uuid))
                                    .filter(a => !!a)
                                    .map(a => a.id);
                                const resourceIds = (view.resourceIds || [])
                                    .map(uuid => resources.findResourceVoorId('/apiv0/resource/' + uuid))
                                    .filter(r => !!r)
                                    .map(r => r.id);
                                $scope.slicesLoader.navigator.selecteerAgendasEnResources(calendarIds, resourceIds);
                            };

                            $scope.addSavedView = function (name, collapsedTitles) {
                                const uuids = $scope.slicesLoader.criteria.agendas.map(id => id.split('/').pop());
                                const resourceUuids = $scope.slicesLoader.criteria.resources.map(id => id.split('/').pop());
                                UserProfileService.addView(name, uuids, resourceUuids, collapsedTitles);
                            };

                            $scope.updateSavedView = function (index, collapsedTitles) {
                                const uuids = $scope.slicesLoader.criteria.agendas.map(id => id.split('/').pop());
                                const resourceUuids = $scope.slicesLoader.criteria.resources.map(id => id.split('/').pop());
                                UserProfileService.updateView(index, uuids, resourceUuids, collapsedTitles);
                            };

                            $scope.renameSavedView = function (index, newName) {
                                UserProfileService.renameView(index, newName);
                            };

                            $scope.deleteSavedView = function (index) {
                                UserProfileService.deleteView(index);
                            };
                        }
                    },
                    'menutop@': {
                        templateUrl: '/partials/components/afspraak.zoeken.html',
                        controller: 'afspraakZoekenController'
                    }
                }
            });

            agendaNestedStatesConfigurator($stateProvider, 'agenda.initial');
        });
})();